import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
} from "@angular/router";
import { Observable } from "rxjs";
import { ApiService } from "../services/api/api.service";

@Injectable({ providedIn: "root" })
export default class PasswordUpdateGuard implements CanActivate {
  /**
   *
   * @param router
   * @param _store
   */
  constructor(
    private router: Router,
    private apiService: ApiService,
  ) {
    //
  }

  /**
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      const { uuid } = route.params;

      this.apiService.post(`password/check/${uuid}`, {}).subscribe(
        (response) => {
          observer.next(true);
        },
        (err) => {
          this.router.navigate([""]), observer.next(false);
        },
      );
    });
  }
}
